import {createSlice} from '@reduxjs/toolkit';
import {httpPost, httpGet} from '../../../../util/Rest';
import {CLIENT_MAINTENANCE} from '../../../../constants/MicroServiceConstants';
import {LETTER_SERVICE_1000} from '../../../../constants/Lookup';

const initialData = {
  collectionDepartmentData: {},
  dropDownData: {},
  collectionDepartmentStatus: null,
  isLoading: false,
  errorMsg: null,
  successMsg: null,
};

const slice = createSlice({
  name: 'collectionDepartments',
  initialState: {
    ...initialData,
  },
  reducers: {
    fetchStart: (state) => {
      state.isLoading = true;
      state.errorMsg = null;
    },
    fetchCollectionDepartmentData: (state, action) => {
      state.collectionDepartmentData = action.payload;
      state.isLoading = false;
      state.errorMsg = null;
    },
    postCollectionDepartmentData: (state, action) => {
      state.collectionDepartmentStatus = action.payload.status;
      state.isLoading = false;
      state.errorMsg = null;
      state.successMsg = action.payload.response;
    },
    fetchDropDownData: (state, action) => {
      state.dropDownData = action.payload;
      state.isLoading = false;
      state.errorMsg = null;
    },
    resetCollectionDepartment: (state) => {
      state.collectionDepartmentStatus = null;
      state.isLoading = false;
    },
    fetchError: (state, action) => {
      state.errorMsg = action.payload;
      state.isLoading = false;
    },
    resetMsg: (state, action) => {
      state.successMsg = null;
      state.errorMsg = null;
      state.isLoading = false;
    },
  },
});

export default slice.reducer;

// Actions

const {
  fetchStart,
  fetchCollectionDepartmentData,
  postCollectionDepartmentData,
  resetMsg,
  resetCollectionDepartment,
  fetchDropDownData,
  fetchError,
} = slice.actions;
export const fetchCollectionDepartment = (clientNumber) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpGet(`${CLIENT_MAINTENANCE}/find/collectiondepartments/${clientNumber}`)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(fetchCollectionDepartmentData(data.response));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error?.data?.error));
      });
  };
};
export const fetchDropdown = (accountNumber) => {
  return (dispatch) => {
    dispatch(fetchStart());
    Promise.all([
      httpPost('lookup/find/all/lookup', {
        typeCode: [LETTER_SERVICE_1000],
      }),
    ])
      .then((data) => {
        const lookUpApiData = data && data[0] ? data[0] : null;
        if (lookUpApiData && lookUpApiData.status && lookUpApiData.status === 200) {
          dispatch(fetchDropDownData(lookUpApiData.data));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error?.data?.error));
      });
  };
};

export const postCollectionDepartment = (details) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpPost(`${CLIENT_MAINTENANCE}/save/collectiondepartments`, details)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(postCollectionDepartmentData(data));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};
export const resetMessage = () => {
  return (dispatch) => {
    dispatch(resetMsg());
  };
};
export const resetStatus = () => {
  return (dispatch) => {
    dispatch(resetCollectionDepartment());
  };
};
